import React from 'react';
import styled from 'styled-components';
import { Text } from '../design-system';

const UnlimitedSeatsUL = styled.ul<{ fontSize?: number }>`
  font-size: ${(p) => p.fontSize};
  margin: 0 auto;
  text-align: center;
`;

interface PlanDetailsProps {
  listItems: string[];
  textItems: string[];
  fontSize?: number;
}

const PlanDetails = ({
  listItems,
  textItems,
  fontSize = 16,
}: PlanDetailsProps) => (
  <>
    <UnlimitedSeatsUL fontSize={fontSize - 2}>
      {listItems.map((text) => (
        <li key={text}>{text}</li>
      ))}
    </UnlimitedSeatsUL>
    {textItems.map((text) => (
      <Text key={text} fontSize={fontSize}>
        {text}
        <br />
      </Text>
    ))}
  </>
);

export default PlanDetails;
